import styled, { keyframes, css } from 'styled-components';
import { InProgress } from '../Icons/components/InProgress.js';

const RotateAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;
const AnimatedInProgressIcon = styled(InProgress).withConfig({
    displayName: "styles__AnimatedInProgressIcon",
    componentId: "sc-956e337a-0"
})`
    animation: ${RotateAnimation} 2s linear infinite;
`;
const Container = styled.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-956e337a-1"
})`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
`;
const Text = styled.span.withConfig({
    displayName: "styles__Text",
    componentId: "sc-956e337a-2"
})`
    flex: auto;
    color: ${({ color , theme  })=>color || theme.colors["Level 4"]};
    ${(props)=>css(props.theme.typography.Paragraph)}
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
const IconWrap = styled.div.withConfig({
    displayName: "styles__IconWrap",
    componentId: "sc-956e337a-3"
})`
    flex: none;
    display: flex;
    margin-right: ${(props)=>props.theme.spacers.M};
`;

export { AnimatedInProgressIcon, Container, IconWrap, Text };
